import React, { Component } from 'react'
import DatePicker from 'react-datepicker'

class InAppMessage extends Component {
  constructor(props) {
    super(props)
    this.state = {
      trackObjective: false,
      priority: 1,
      gender: 'Female',
      genderValidation: false,
      conditionType: 'None',
      ageGroup: '18 - 24',
      campaignTargetImpressions: 10,
      campaignTargetImpressionsPerUser: 4,
      campaignStartDateTime: props.scheduleDate,
      campaignEndDateTime: new Date(new Date().setDate(new Date().getDate() + 1)),
      noOfTimes: 'Once',
      campaignPosition: '',
      isInAppMessage: props.isInAppMessage,
    }
    this.campaignPriorityValidation = false
    this.campaignDateTimeValidation = false
    this.campaignTargetImpressionsValidations = false
    this.campaignTargetImpressionsPerUserValidations = false
    this.campaignTIPUGTTIValidation = false
  }
  componentDidMount = () => {
    if (
      this.props.isInAppMessage &&
      this.props.inAppMessageDetails &&
      this.props.inAppMessageDetails != undefined &&
      this.props.inAppMessageDetails != null &&
      Object.keys(this.props.inAppMessageDetails).length > 0
    ) {
      this.setState(
        {
          isInAppMessage: true,
          trackObjective: this.props.inAppMessageDetails.trackObjective,
          priority: isNaN(this.props.inAppMessageDetails.priority)
            ? this.state.priority
            : `${this.props.inAppMessageDetails.priority}`,
          gender: this.props.inAppMessageDetails.gender,
          ageGroup: this.props.inAppMessageDetails.ageGroup,
          noOfTimes: this.props.inAppMessageDetails.noOfTimes,
          campaignTargetImpressions:
            this.props.inAppMessageDetails.campaignTargetImpressions != undefined &&
            this.props.inAppMessageDetails.campaignTargetImpressions != null
              ? `${this.props.inAppMessageDetails.campaignTargetImpressions}`
              : this.state.campaignTargetImpressions,
          campaignTargetImpressionsPerUser:
            this.props.inAppMessageDetails.campaignTargetImpressionsPerUser != undefined &&
            this.props.inAppMessageDetails.campaignTargetImpressionsPerUser != null
              ? `${this.props.inAppMessageDetails.campaignTargetImpressionsPerUser}`
              : this.state.campaignTargetImpressionsPerUser,
          conditionType: this.props.inAppMessageDetails.conditionType,
          campaignStartDateTime:
            typeof this.props.inAppMessageDetails.campaignStartDateTime == 'number'
              ? new Date(parseInt(this.props.inAppMessageDetails.campaignStartDateTime) * 1000)
              : this.props.inAppMessageDetails.campaignStartDateTime,
          campaignEndDateTime:
            typeof this.props.inAppMessageDetails.campaignEndDateTime == 'number'
              ? new Date(parseInt(this.props.inAppMessageDetails.campaignEndDateTime) * 1000)
              : this.props.inAppMessageDetails.campaignEndDateTime,
          campaignPosition: isNaN(this.props.inAppMessageDetails.campaignPosition)
            ? this.state.campaignPosition
            : `${this.props.inAppMessageDetails.campaignPosition}`,
        },
        () => {
          this.callParentMethod()
        }
      )
    }
  }
  checkDateTimeValidations = () => {
    const { campaignStartDateTime, campaignEndDateTime } = this.state
    const campaignStartDateTimeStamp = new Date(campaignStartDateTime).getTime()
    const campaignEndDateTimeStamp = new Date(campaignEndDateTime).getTime()
    if (campaignEndDateTimeStamp - campaignStartDateTimeStamp <= 0) {
      this.campaignDateTimeValidation = true
    } else {
      this.campaignDateTimeValidation = false
    }
  }
  handleChangeCampaignStartDateTime = (campaignStartDateTime) => {
    this.setState(
      {
        campaignStartDateTime,
      },
      () => {
        this.checkDateTimeValidations()
        this.callParentMethod()
      }
    )
  }
  handleChangeCampaignEndDateTime = (campaignEndDateTime) => {
    this.setState(
      {
        campaignEndDateTime,
      },
      () => {
        this.checkDateTimeValidations()
        this.callParentMethod()
      }
    )
  }
  handleChangeShowCampaignOption = (noOfTimes) => {
    this.setState(
      {
        noOfTimes,
      },
      () => {
        this.callParentMethod()
      }
    )
  }
  handleChangeCampaignTargetImpressions = (campaignTargetImpressions) => {
    this.setState(
      {
        campaignTargetImpressions,
      },
      () => {
        this.state.campaignTargetImpressions == ''
          ? (this.campaignTargetImpressionsValidations = true)
          : (this.campaignTargetImpressionsValidations = false)
        parseInt(this.state.campaignTargetImpressionsPerUser) >
        parseInt(this.state.campaignTargetImpressions)
          ? (this.campaignTIPUGTTIValidation = true)
          : (this.campaignTIPUGTTIValidation = false)
        this.callParentMethod()
      }
    )
  }
  handleChangeCampaignTargetImpressionsPerUser = (campaignTargetImpressionsPerUser) => {
    this.setState(
      {
        campaignTargetImpressionsPerUser,
      },
      () => {
        this.state.campaignTargetImpressionsPerUser == ''
          ? (this.campaignTargetImpressionsPerUserValidations = true)
          : (this.campaignTargetImpressionsPerUserValidations = false)
        parseInt(this.state.campaignTargetImpressionsPerUser) >
        parseInt(this.state.campaignTargetImpressions)
          ? (this.campaignTIPUGTTIValidation = true)
          : (this.campaignTIPUGTTIValidation = false)
        this.callParentMethod()
      }
    )
  }

  // handleChangeCampaignPriority = (priority) => {
  //   this.setState(
  //     {
  //       priority,
  //     },
  //     () => {
  //       this.state.priority == ''
  //         ? (this.campaignPriorityValidation = true)
  //         : (this.campaignPriorityValidation = false)
  //       this.callParentMethod()
  //     }
  //   )
  // }
  handleChangeConditionType = (conditionType) => {
    this.setState(
      {
        conditionType,
      },
      () => {
        this.callParentMethod()
      }
    )
  }
  handleChangeAgeGroup = (ageGroup) => {
    this.setState(
      {
        ageGroup,
      },
      () => {
        this.callParentMethod()
      }
    )
  }
  handleChangeGender = (gender) => {
    this.setState(
      {
        gender,
      },
      () => {
        this.callParentMethod()
      }
    )
  }
  handleChangeTrackObjective = (e) => {
    this.setState(
      {
        trackObjective: e.target.checked,
      },
      () => {
        this.callParentMethod()
      }
    )
  }
  handleChangeCampaignPosition = (campaignPosition) => {
    this.setState(
      {
        campaignPosition,
      },
      () => {
        this.callParentMethod()
      }
    )
  }
  handleCheckCampaignPosition = () => {
    return this.state.campaignPosition == ''
  }
  callParentMethod = () => {
    const inAppMessageDetails = {
      conditionType: this.state.conditionType,
      gender: this.state.gender,
      ageGroup: this.state.ageGroup,
      trackObjective: this.state.trackObjective,
      noOfTimes: this.state.noOfTimes,
      priority: parseInt(this.state.priority),
      campaignStartDateTime: this.state.campaignStartDateTime,
      campaignEndDateTime: this.state.campaignEndDateTime,
      campaignPosition: parseInt(this.state.campaignPosition),
      campaignTargetImpressions: parseInt(this.state.campaignTargetImpressions),
      targetImpressions: parseInt(this.state.campaignTargetImpressions),
    }
    if (this.state.noOfTimes == 'campaignNoOfTimes') {
      inAppMessageDetails.campaignTargetImpressionsPerUser = parseInt(
        this.state.campaignTargetImpressionsPerUser
      )
    }
    this.props.updateInAppMessageDetails(inAppMessageDetails)
  }
  handleChangeInAppMessageSwitch = (e) => {
    this.setState(
      {
        isInAppMessage: e.target.checked,
      },
      () => {
        this.props.handleChangeInAppMessageSwitch(e)
        // this.callParentMethod()
      }
    )
  }

  render() {
    const {
      campaignEndDateTime,
      campaignStartDateTime,
      noOfTimes,
      campaignTargetImpressions,
      priority,
      conditionType,
      ageGroup,
      gender,
      trackObjective,
      campaignPosition,
      campaignTargetImpressionsPerUser,
      isInAppMessage,
    } = this.state
    return (
      <div>
        <details open={isInAppMessage}>
          <summary>Create Campaign</summary>
          <div className='custom-control custom-switch'>
            <input
              type='checkbox'
              className='custom-control-input'
              onChange={(e) => this.handleChangeInAppMessageSwitch(e)}
              checked={isInAppMessage}
              id='campaign'
              readOnly
            />
            <label className='custom-control-label' htmlFor='campaign'>
              Enable Campaign
            </label>
          </div>
          {isInAppMessage ? (
            <div>
              <div class='row mb-2'>
                <label for='text'>Campaign Position From Top</label>
                <input
                  id='campaignPosition'
                  type='text'
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault()
                    }
                  }}
                  onChange={(e) => {
                    this.handleChangeCampaignPosition(e.target.value)
                  }}
                  value={campaignPosition}
                  placeholder='Please Enter Campaign Position'
                ></input>
                {this.handleCheckCampaignPosition() ? (
                  <text for='text' style={{ color: 'red', fontSize: 10 }}>
                    Campaign Position Cannot be Empty
                  </text>
                ) : null}
              </div>
              <div className='custom-control custom-switch'>
                <input
                  type='checkbox'
                  className='custom-control-input'
                  onChange={(e) => this.handleChangeTrackObjective(e)}
                  checked={trackObjective}
                  id='trackObjective'
                />
                <label className='custom-control-label' htmlFor='trackObjective'>
                  Track Objective
                </label>
              </div>
              <div class='row mb-2'>
                <label for='text'>Campaign Start Date And Time</label>
                <DatePicker
                  disabled={true}
                  dateFormat={'dd/MM/yyyy HH:mm '}
                  minDate={new Date()}
                  selected={this.props.scheduleDate}
                  showTimeSelect
                  onChange={(date) => this.handleChangeCampaignStartDateTime(date)}
                />
              </div>
              <div class='row mb-2'>
                <label for='text'>Campaign End Date And Time</label>
                <DatePicker
                  dateFormat={'dd/MM/yyyy HH:mm '}
                  minDate={new Date()}
                  selected={campaignEndDateTime}
                  showTimeSelect
                  onChange={(date) => this.handleChangeCampaignEndDateTime(date)}
                />
              </div>
              {this.campaignDateTimeValidation ? (
                <text for='text' style={{ color: 'red', fontSize: 10 }}>
                  Campaign End Date Time must be Greater Than Campaign Start Date Time
                </text>
              ) : null}
              {/* <div class='row mb-2'>
                <label for='text'>Priority </label>
                <input
                  id='priority'
                  type='text'
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault()
                    }
                  }}
                  onChange={(e) => {
                    this.handleChangeCampaignPriority(e.target.value)
                  }}
                  value={priority}
                  placeholder='Please Enter Priority'
                ></input>
                {this.campaignPriorityValidation ? (
                  <text for='text' style={{ color: 'red', fontSize: 10 }}>
                    Campaign Priority Cannot be Empty
                  </text>
                ) : null}
              </div> */}
              <div class='row mb-2'>
                <label for='text'>Campaign Target Impressions </label>
                <input
                  id='campaignTargetImpressions'
                  type='text'
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault()
                    }
                  }}
                  onChange={(e) => {
                    this.handleChangeCampaignTargetImpressions(e.target.value)
                  }}
                  disabled={
                    this.props.contentStatus != undefined &&
                    this.props.contentStatus != null &&
                    this.props.contentStatus == 'm#published' &&
                    this.props.isPreviouslyCampaign != undefined &&
                    this.props.isPreviouslyCampaign != null &&
                    this.props.isPreviouslyCampaign
                      ? true
                      : false
                  }
                  value={campaignTargetImpressions}
                  placeholder='Please Enter Campaign Target Impressions'
                ></input>
                {this.campaignTargetImpressionsValidations ? (
                  <text for='text' style={{ color: 'red', fontSize: 10 }}>
                    Campaign Target Impressions Cannot be Empty
                  </text>
                ) : null}
              </div>
              <div class='mb-2'>
                <div class='row'>
                  <label for='text'>Show this to User</label>
                </div>
                <div class='row'>
                  <div>
                    <input
                      value={'Once'}
                      type='radio'
                      checked={noOfTimes == 'Once'}
                      onChange={() => {
                        this.handleChangeShowCampaignOption('Once')
                      }}
                      disabled={
                        this.props.contentStatus != undefined &&
                        this.props.contentStatus != null &&
                        this.props.contentStatus == 'm#published' &&
                        this.props.isPreviouslyCampaign != undefined &&
                        this.props.isPreviouslyCampaign != null &&
                        this.props.isPreviouslyCampaign
                          ? true
                          : false
                      }
                    ></input>
                    <text for='Once'>Once</text>
                  </div>
                  <div>
                    <input
                      value={'Unlimited'}
                      type='radio'
                      checked={noOfTimes == 'Unlimited'}
                      onChange={() => {
                        this.handleChangeShowCampaignOption('Unlimited')
                      }}
                      disabled={
                        this.props.contentStatus != undefined &&
                        this.props.contentStatus != null &&
                        this.props.contentStatus == 'm#published' &&
                        this.props.isPreviouslyCampaign != undefined &&
                        this.props.isPreviouslyCampaign != null &&
                        this.props.isPreviouslyCampaign
                          ? true
                          : false
                      }
                    ></input>
                    <text for='Unlimited'>Unlimited</text>
                  </div>
                  <div>
                    <input
                      value={'campaignNoOfTimes'}
                      type='radio'
                      checked={noOfTimes == 'campaignNoOfTimes'}
                      onChange={() => {
                        this.handleChangeShowCampaignOption('campaignNoOfTimes')
                      }}
                      disabled={
                        this.props.contentStatus != undefined &&
                        this.props.contentStatus != null &&
                        this.props.contentStatus == 'm#published' &&
                        this.props.isPreviouslyCampaign != undefined &&
                        this.props.isPreviouslyCampaign != null &&
                        this.props.isPreviouslyCampaign
                          ? true
                          : false
                      }
                    ></input>
                    <text for='campaignNoOfTimes'>Number Of Times</text>
                  </div>
                </div>
              </div>
              <div>
                {noOfTimes == 'campaignNoOfTimes' ? (
                  <div>
                    <div class='row mb-2'>
                      <label for='text'>Number Of Times</label>
                      <input
                        id='campaignTargetImpressionsPerUser'
                        type='text'
                        onKeyPress={(event) => {
                          if (!/[0-9]/.test(event.key)) {
                            event.preventDefault()
                          }
                        }}
                        onChange={(e) => {
                          this.handleChangeCampaignTargetImpressionsPerUser(e.target.value)
                        }}
                        disabled={
                          this.props.contentStatus != undefined &&
                          this.props.contentStatus != null &&
                          this.props.contentStatus == 'm#published' &&
                          this.props.isPreviouslyCampaign != undefined &&
                          this.props.isPreviouslyCampaign != null &&
                          this.props.isPreviouslyCampaign
                            ? true
                            : false
                        }
                        value={campaignTargetImpressionsPerUser}
                        placeholder='Please Enter Campaign Target Impressions User'
                      ></input>
                      {this.campaignTargetImpressionsPerUserValidations ? (
                        <text for='text' style={{ color: 'red', fontSize: 10 }}>
                          Campaign Target Impressions Per User Cannot be Empty
                        </text>
                      ) : null}
                      {this.campaignTIPUGTTIValidation ? (
                        <text for='text' style={{ color: 'red', fontSize: 10 }}>
                          Campaign Target Impressions Per User Cannot be more than Campign Target
                          Impressions
                        </text>
                      ) : null}
                    </div>
                  </div>
                ) : null}
              </div>
              <div class='mb-2'>
                <div class='row'>
                  <label for='text'>Condition Type</label>
                </div>
                <div class='row'>
                  <div>
                    <input
                      value={'None'}
                      type='radio'
                      checked={conditionType == 'None'}
                      onChange={() => {
                        this.handleChangeConditionType('None')
                      }}
                      disabled={
                        this.props.contentStatus != undefined &&
                        this.props.contentStatus != null &&
                        this.props.contentStatus == 'm#published' &&
                        this.props.isPreviouslyCampaign != undefined &&
                        this.props.isPreviouslyCampaign != null &&
                        this.props.isPreviouslyCampaign
                          ? true
                          : false
                      }
                    ></input>
                    <text for='None'>None</text>
                  </div>
                  <div>
                    <input
                      value={'ageGroup'}
                      type='radio'
                      checked={conditionType == 'ageGroup'}
                      onChange={() => {
                        this.handleChangeConditionType('ageGroup')
                      }}
                      disabled={
                        this.props.contentStatus != undefined &&
                        this.props.contentStatus != null &&
                        this.props.contentStatus == 'm#published' &&
                        this.props.isPreviouslyCampaign != undefined &&
                        this.props.isPreviouslyCampaign != null &&
                        this.props.isPreviouslyCampaign
                          ? true
                          : false
                      }
                    ></input>
                    <text for='ageGroup'>ageGroup</text>
                  </div>
                  <div>
                    <input
                      value={'gender'}
                      type='radio'
                      checked={conditionType == 'gender'}
                      onChange={() => {
                        this.handleChangeConditionType('gender')
                      }}
                      disabled={
                        this.props.contentStatus != undefined &&
                        this.props.contentStatus != null &&
                        this.props.contentStatus == 'm#published' &&
                        this.props.isPreviouslyCampaign != undefined &&
                        this.props.isPreviouslyCampaign != null &&
                        this.props.isPreviouslyCampaign
                          ? true
                          : false
                      }
                    ></input>
                    <text for='gender'>gender</text>
                  </div>
                </div>
              </div>
              {conditionType == 'ageGroup' ? (
                <div class='mb-2'>
                  <div class='row'>
                    <label for='text'>age Group</label>
                  </div>
                  <div class='row'>
                    <div>
                      <input
                        value={'18 - 24'}
                        type='radio'
                        checked={ageGroup == '18 - 24'}
                        onChange={() => {
                          this.handleChangeAgeGroup('18 - 24')
                        }}
                        disabled={
                          this.props.contentStatus != undefined &&
                          this.props.contentStatus != null &&
                          this.props.contentStatus == 'm#published' &&
                          this.props.isPreviouslyCampaign != undefined &&
                          this.props.isPreviouslyCampaign != null &&
                          this.props.isPreviouslyCampaign
                            ? true
                            : false
                        }
                      ></input>
                      <text for='18-24'>18 - 24</text>
                    </div>
                    <div>
                      <input
                        value={'25 - 34'}
                        type='radio'
                        checked={ageGroup == '25 - 34'}
                        onChange={() => {
                          this.handleChangeAgeGroup('25 - 34')
                        }}
                        disabled={
                          this.props.contentStatus != undefined &&
                          this.props.contentStatus != null &&
                          this.props.contentStatus == 'm#published' &&
                          this.props.isPreviouslyCampaign != undefined &&
                          this.props.isPreviouslyCampaign != null &&
                          this.props.isPreviouslyCampaign
                            ? true
                            : false
                        }
                      ></input>
                      <text for='25-34'>25 - 34</text>
                    </div>
                    <div>
                      <input
                        value={'35+'}
                        type='radio'
                        checked={ageGroup == '35+'}
                        onChange={() => {
                          this.handleChangeAgeGroup('35+')
                        }}
                        disabled={
                          this.props.contentStatus != undefined &&
                          this.props.contentStatus != null &&
                          this.props.contentStatus == 'm#published' &&
                          this.props.isPreviouslyCampaign != undefined &&
                          this.props.isPreviouslyCampaign != null &&
                          this.props.isPreviouslyCampaign
                            ? true
                            : false
                        }
                      ></input>
                      <text for='35+'>35+</text>
                    </div>
                  </div>
                </div>
              ) : null}
              {conditionType == 'gender' ? (
                <div class='mb-2'>
                  <div class='row'>
                    <label for='text'>Gender</label>
                  </div>
                  <div class='row'>
                    <div>
                      <input
                        value={'Female'}
                        type='radio'
                        checked={gender == 'Female'}
                        onChange={() => {
                          this.handleChangeGender('Female')
                        }}
                        disabled={
                          this.props.contentStatus != undefined &&
                          this.props.contentStatus != null &&
                          this.props.contentStatus == 'm#published' &&
                          this.props.isPreviouslyCampaign != undefined &&
                          this.props.isPreviouslyCampaign != null &&
                          this.props.isPreviouslyCampaign
                            ? true
                            : false
                        }
                      ></input>
                      <text for='female'>Female</text>
                    </div>
                    <div>
                      <input
                        value={'Male'}
                        type='radio'
                        checked={gender == 'Male'}
                        onChange={() => {
                          this.handleChangeGender('Male')
                        }}
                        disabled={
                          this.props.contentStatus != undefined &&
                          this.props.contentStatus != null &&
                          this.props.contentStatus == 'm#published' &&
                          this.props.isPreviouslyCampaign != undefined &&
                          this.props.isPreviouslyCampaign != null &&
                          this.props.isPreviouslyCampaign
                            ? true
                            : false
                        }
                      ></input>
                      <text for='male'>Male</text>
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
          ) : null}
        </details>
      </div>
    )
  }
}

export default InAppMessage
